// Central business/site configuration for Summit Neighbor Fencing Co.
// Edit business data here — it flows to every component sitewide.

export const site = {
  name: "Summit Neighbor Fencing Co.",
  shortName: "Summit Neighbor Fencing",
  legalName: "Summit Neighbor Fencing Co. LLC",
  tagline: "Premium Fencing in Summit County, Colorado",
  description:
    "Professional fence installation, repair, and custom fencing in Dillon and across Summit County, Colorado. Wood, picket, chain link, aluminum, and construction perimeter fencing — built to handle high-country weather.",

  // Phone — approved business/call-forwarding number.
  // (Other-marketing-company number 970-432-8046 is intentionally NOT used.)
  phone: "(970) 333-1959",
  phoneHref: "tel:+19703331959",

  email: "summitneighborfencing@gmail.com",
  emailHref: "mailto:summitneighborfencing@gmail.com",

  city: "Dillon",
  state: "Colorado",
  stateAbbr: "CO",
  serviceArea: "Dillon & Summit County, Colorado",
  serviceRadius: "30-mile radius",

  hours: [
    { days: "Monday – Friday", time: "7:00 AM – 7:00 PM" },
    { days: "Saturday", time: "7:00 AM – 5:00 PM" },
    { days: "Sunday", time: "Closed" },
  ],
  hoursShort: "Mon–Fri 7 AM – 7 PM · Sat 7 AM – 5 PM",

  domain: "summitneighborfencing.com",
  url: "https://summitneighborfencing.com",

  social: {
    instagram: "https://www.instagram.com/summitneighborfencing/",
  },

  // High-ticket business → referral reward offer + free estimates.
  offer: {
    short: "Free estimates + refer a neighbor & earn a reward",
    referral: "Refer a neighbor — when they book, you both get a reward.",
  },
} as const;

export type Site = typeof site;
